(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["seo-blog-template"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupTagRail = (rail) => {
      if (!rail || rail.dataset.dragScrollBound === 'true') return;

      rail.dataset.dragScrollBound = 'true';

      let activePointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let didDrag = false;
      let suppressClick = false;

      const endDrag = () => {
        if (activePointerId !== null && rail.hasPointerCapture(activePointerId)) {
          rail.releasePointerCapture(activePointerId);
        }

        activePointerId = null;
        rail.classList.remove('is-dragging');

        if (didDrag) {
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 160);
        }

        didDrag = false;
      };

      rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (rail.scrollWidth <= rail.clientWidth) return;

        activePointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = rail.scrollLeft;
        didDrag = false;
      });

      rail.addEventListener('pointermove', (event) => {
        if (activePointerId !== event.pointerId) return;

        const deltaX = event.clientX - startX;

        if (!didDrag && Math.abs(deltaX) > 6) {
          didDrag = true;
          rail.classList.add('is-dragging');

          if (!rail.hasPointerCapture(activePointerId)) {
            rail.setPointerCapture(activePointerId);
          }
        }

        if (!didDrag) return;

        rail.scrollLeft = startScrollLeft - deltaX;
      });

      rail.addEventListener('pointerup', (event) => {
        if (activePointerId !== event.pointerId) return;
        endDrag();
      });

      rail.addEventListener('pointercancel', (event) => {
        if (activePointerId !== event.pointerId) return;
        endDrag();
      });

      rail.addEventListener('click', (event) => {
        if (!suppressClick) return;

        if (event.target.closest('a')) {
          suppressClick = false;
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, true);
    };

    const setupArticleSuggest = (form) => {
      if (!form || form.dataset.articleSuggestBound === 'true') return;

      const input = form.querySelector('[data-seo-blog-suggest-input]');
      const results = form.querySelector('[data-seo-blog-suggest-results]');

      if (!input || !results) return;

      form.dataset.articleSuggestBound = 'true';

      const minQueryLength = 2;
      const resultLimit = 10;
      const cache = new Map();
      let debounceTimer = null;
      let abortController = null;
      let activeIndex = -1;
      let requestId = 0;

      const root = window.Shopify?.routes?.root || '/';

      const buildFullSearchUrl = (query) => {
        const url = new URL(form.action, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'article');
        url.searchParams.set('options[prefix]', 'last');
        return url.toString();
      };

      const setExpanded = (expanded) => {
        input.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      };

      const getSuggestionLinks = () => Array.from(results.querySelectorAll('.seo-blog__suggest-link'));

      const clearActive = () => {
        getSuggestionLinks().forEach((link) => link.classList.remove('is-active'));
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
      };

      const setActive = (index) => {
        const links = getSuggestionLinks();

        if (links.length === 0) {
          clearActive();
          return;
        }

        activeIndex = (index + links.length) % links.length;

        links.forEach((link, linkIndex) => {
          const isActive = linkIndex === activeIndex;
          link.classList.toggle('is-active', isActive);

          if (isActive) {
            input.setAttribute('aria-activedescendant', link.id);
            link.scrollIntoView({ block: 'nearest' });
          }
        });
      };

      const hideResults = () => {
        results.hidden = true;
        results.replaceChildren();
        form.classList.remove('is-loading');
        setExpanded(false);
        clearActive();
      };

      const renderState = (message) => {
        results.replaceChildren();

        const state = document.createElement('p');
        state.className = 'seo-blog__suggest-state';
        state.textContent = message;
        results.append(state);

        results.hidden = false;
        setExpanded(true);
        clearActive();
      };

      const renderArticles = (articles, query) => {
        results.replaceChildren();
        clearActive();

        if (articles.length === 0) {
          renderState('No matching articles.');
          return;
        }

        const list = document.createElement('ul');
        list.className = 'seo-blog__suggest-list';
        list.setAttribute('role', 'presentation');

        articles.forEach((article, index) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          const title = document.createElement('span');

          link.id = `${input.id}-Option-${index}`;
          link.className = 'seo-blog__suggest-link';
          link.href = article.url || buildFullSearchUrl(query);
          link.setAttribute('role', 'option');
          link.dataset.instant = '';

          title.className = 'seo-blog__suggest-title';
          title.textContent = article.title || 'Untitled article';
          link.append(title);

          if (article.blog_title || article.author) {
            const meta = document.createElement('span');
            meta.className = 'seo-blog__suggest-meta';
            meta.textContent = article.blog_title || article.author;
            link.append(meta);
          }

          link.addEventListener('mouseenter', () => setActive(index));
          item.setAttribute('role', 'presentation');
          item.append(link);
          list.append(item);
        });

        const allResultsLink = document.createElement('a');
        allResultsLink.className = 'seo-blog__suggest-all';
        allResultsLink.href = buildFullSearchUrl(query);
        allResultsLink.textContent = `View all article results for "${query}"`;

        results.append(list, allResultsLink);
        results.hidden = false;
        setExpanded(true);
      };

      const fetchArticles = async (query) => {
        if (cache.has(query)) {
          renderArticles(cache.get(query), query);
          return;
        }

        abortController?.abort();
        abortController = new AbortController();

        const currentRequestId = ++requestId;
        const suggestUrl = new URL(`${root}search/suggest.json`, window.location.origin);
        suggestUrl.searchParams.set('q', query);
        suggestUrl.searchParams.set('resources[type]', 'article');
        suggestUrl.searchParams.set('resources[limit]', String(resultLimit));
        suggestUrl.searchParams.set('resources[limit_scope]', 'each');
        suggestUrl.searchParams.set('resources[options][fields]', 'title,body');

        form.classList.add('is-loading');
        renderState('Searching articles...');

        try {
          const response = await fetch(suggestUrl.toString(), {
            headers: { Accept: 'application/json' },
            signal: abortController.signal
          });

          if (!response.ok) throw new Error('Article suggest request failed');

          const data = await response.json();

          if (currentRequestId !== requestId || input.value.trim() !== query) return;

          const articles = data?.resources?.results?.articles || data?.resources?.articles || [];
          cache.set(query, articles);
          renderArticles(articles, query);
        } catch (error) {
          if (error.name === 'AbortError') return;
          renderState('Article suggestions are unavailable.');
        } finally {
          if (currentRequestId === requestId) {
            form.classList.remove('is-loading');
          }
        }
      };

      const scheduleSearch = () => {
        const query = input.value.trim();
        window.clearTimeout(debounceTimer);

        if (query.length < minQueryLength) {
          abortController?.abort();
          hideResults();
          return;
        }

        debounceTimer = window.setTimeout(() => fetchArticles(query), 220);
      };

      input.addEventListener('input', scheduleSearch);

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= minQueryLength && results.childElementCount > 0) {
          results.hidden = false;
          setExpanded(true);
        }
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          hideResults();
          return;
        }

        if (results.hidden) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setActive(activeIndex + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActive(activeIndex - 1);
        } else if (event.key === 'Enter' && activeIndex >= 0) {
          const activeLink = getSuggestionLinks()[activeIndex];

          if (activeLink) {
            event.preventDefault();
            activeLink.click();
          }
        }
      });

      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) {
          hideResults();
        }
      });
    };

    const setupProductCarousel = (carousel) => {
      if (!carousel || carousel.dataset.productCarouselBound === 'true') return;

      const track = carousel.querySelector('[data-seo-blog-product-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-seo-blog-product-slide]'));
      const previousButton = carousel.querySelector('[data-seo-blog-product-prev]');
      const nextButton = carousel.querySelector('[data-seo-blog-product-next]');
      const dots = Array.from(carousel.querySelectorAll('[data-seo-blog-product-dot]'));

      if (!track || slides.length === 0) return;

      carousel.dataset.productCarouselBound = 'true';

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplayEnabled = carousel.dataset.autoplay === 'true' && slides.length > 1;
      const autoplayInterval = Math.max(Number.parseInt(carousel.dataset.autoplayInterval, 10) || 5000, 3000);
      let activeIndex = 0;
      let autoplayTimer = null;
      let scrollFrame = null;
      let isPointerOver = false;
      let hasFocusWithin = false;

      const normalizeIndex = (index) => (index + slides.length) % slides.length;

      const updateState = (index) => {
        activeIndex = normalizeIndex(index);

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.toggleAttribute('inert', !isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
        });
      };

      const goTo = (index, behavior = 'smooth') => {
        const nextIndex = normalizeIndex(index);
        const nextSlide = slides[nextIndex];

        updateState(nextIndex);
        track.scrollTo({
          left: nextSlide.offsetLeft - track.offsetLeft,
          behavior: reducedMotion.matches ? 'auto' : behavior
        });
      };

      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      };

      const startAutoplay = () => {
        stopAutoplay();

        if (!autoplayEnabled || reducedMotion.matches || document.hidden || isPointerOver || hasFocusWithin) return;

        autoplayTimer = window.setInterval(() => {
          goTo(activeIndex + 1);
        }, autoplayInterval);
      };

      const restartAutoplay = () => {
        stopAutoplay();
        startAutoplay();
      };

      previousButton?.addEventListener('click', () => {
        goTo(activeIndex - 1);
        restartAutoplay();
      });

      nextButton?.addEventListener('click', () => {
        goTo(activeIndex + 1);
        restartAutoplay();
      });

      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => {
          goTo(dotIndex);
          restartAutoplay();
        });
      });

      track.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowLeft') nextIndex = activeIndex - 1;
        if (event.key === 'ArrowRight') nextIndex = activeIndex + 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = slides.length - 1;
        if (nextIndex === null) return;

        event.preventDefault();
        goTo(nextIndex);
        restartAutoplay();
      });

      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const closestIndex = slides.reduce((closest, slide, slideIndex) => {
            const currentDistance = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
            const closestDistance = Math.abs(slides[closest].offsetLeft - track.offsetLeft - track.scrollLeft);
            return currentDistance < closestDistance ? slideIndex : closest;
          }, activeIndex);

          if (closestIndex !== activeIndex) updateState(closestIndex);
        });
      }, { passive: true });

      carousel.addEventListener('pointerenter', () => {
        isPointerOver = true;
        stopAutoplay();
      });

      carousel.addEventListener('pointerleave', () => {
        isPointerOver = false;
        startAutoplay();
      });

      carousel.addEventListener('focusin', () => {
        hasFocusWithin = true;
        stopAutoplay();
      });

      carousel.addEventListener('focusout', (event) => {
        if (carousel.contains(event.relatedTarget)) return;
        hasFocusWithin = false;
        startAutoplay();
      });

      const handleVisibilityChange = () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      };

      const handleReducedMotionChange = () => {
        if (reducedMotion.matches) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      };

      const handleResize = () => goTo(activeIndex, 'auto');

      document.addEventListener('visibilitychange', handleVisibilityChange);
      reducedMotion.addEventListener('change', handleReducedMotionChange);
      window.addEventListener('resize', handleResize);

      carousel.seoBlogCarouselCleanup = () => {
        stopAutoplay();
        window.cancelAnimationFrame(scrollFrame);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        reducedMotion.removeEventListener('change', handleReducedMotionChange);
        window.removeEventListener('resize', handleResize);
      };

      updateState(0);
      startAutoplay();
    };

    const setupSeoBlog = (scope = document) => {
      scope.querySelectorAll('.seo-blog__tag-list').forEach(setupTagRail);
      scope.querySelectorAll('[data-seo-blog-suggest-form]').forEach(setupArticleSuggest);
      scope.querySelectorAll('[data-seo-blog-product-carousel]').forEach(setupProductCarousel);
    };

    setupSeoBlog();

    document.addEventListener('shopify:section:load', (event) => setupSeoBlog(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-seo-blog-product-carousel]').forEach((carousel) => {
        carousel.seoBlogCarouselCleanup?.();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
